import {
  COMPOSITIONS_FETCH,
  COMPOSITIONS_SHOW,
  COMPOSITIONS_HIDE,
  COMPOSITIONS_SAVE,
  COMPOSITIONS_DELETE,
  STYLES_SAVE,
  STYLES_DELETE,
  APPLY_ALL_LAYERS_VISIBILITY,
  STYLES_FETCH,
  COMPOSITIONS_REVERT_CHANGES,
  COMPOSITIONS_LAYER_CHANGED
} from './actions.type';

import {
  COMPOSITIONS_SET,
  COMPOSITIONS_CURRENT_SET,
  STYLES_SET,
  LAYERS_SET,
  APPEND_LAYER,
  WINDOW_API_ERROR_SHOW,
  WINDOW_NOTIFICATION_SHOW,
  DEACTIVATE_ALL_COMPOSITIONS,
  ACTIVATE_CURRENT_COMPOSITION,
  LAYERS_LAYERS_ADD,
  SET_LAYER_VISIBILITY
} from './mutations.type';

import { Api as ApiKompozycje } from '../api/api-kompozycje';
import { Api as ApiStyle } from '../api/api-style';
import MapLayerBuilder from '../models/MapLayerBuilder';
import { LayerTypes } from '../common/layerEnums';
import Composition from '../models/Composition';
import MapLayerStyleBuilder from '../models/MapLayerStyleBuilder';
import { setLayerProperty } from '../common/layersHelper';
import { initValuePrefix } from '../common/layersHelper';

const initialState = {
  compositions: [],
  styles: [],
  layers: [],
  composition: {},
  maximumLayerOrder: null,
  constantLayers: [],
  layersChanged: false
};

const compositionApi = new ApiKompozycje();
const styleApi = new ApiStyle();

var fetchsCompositionsHelper = 0;

export const state = Object.assign({}, initialState);

function hasChanges(groupedConstantLayers, groupedChangedLayers) {
  if (groupedConstantLayers.length !== groupedChangedLayers.length) return true;

  const changedLayers = groupedChangedLayers.map(f => f.layers).flat();
  if (changedLayers.some(l => l.modified)) return true;

  const constantLayers = groupedConstantLayers.map(f => f.layers).flat();
  if (changedLayers.length !== constantLayers.length) return true;

  for (let gi = 0; gi < groupedConstantLayers.length; gi++) {
    if (groupedConstantLayers[gi].name !== groupedChangedLayers[gi].name)
      return true;

    if (
      groupedConstantLayers[gi].layers.length !==
      groupedChangedLayers[gi].layers.length
    )
      return true;

    for (let li = 0; li < groupedConstantLayers[gi].layers.length; li++) {
      if (
        groupedConstantLayers[gi].layers[li].id !==
        groupedChangedLayers[gi].layers[li].id
      )
        return true;
    }
  }
}

function revertPropertyChanges(groupedChangedLayers, skipActive) {
  const changedLayers = groupedChangedLayers.map(f => f.layers).flat();

  changedLayers.forEach(changedLayer => {
    let keys = Object.keys(changedLayer).filter(key => {
      return !key.startsWith(initValuePrefix);
    });

    for (let i = 0; i < keys.length; ++i) {
      let key = keys[i];
      let initialKey = initValuePrefix + key;

      if (key !== 'visible' || !skipActive || !changedLayer.active) {
        if (changedLayer[initialKey] !== undefined) {
          changedLayer[key] = changedLayer[initialKey];
          delete changedLayer[initialKey];
        }
      }
    }

    changedLayer.mapLayer.setVisible(changedLayer.visible);

    if (changedLayer.mapHighResolutionLayer) {
      changedLayer.mapHighResolutionLayer.setVisible(changedLayer.visible);
    }

    changedLayer.modified = false;
  });
}

function revertOrdering(groupedConstantLayers, groupedChangedLayers) {
  const changedLayers = groupedChangedLayers.map(g => g.layers).flat();
  const revertedGroups = [];
  const savedGroupsIds = [];

  for (let gi = 0; gi < groupedConstantLayers.length; gi++) {
    const groupsDiffer =
      groupedConstantLayers[gi].name !== groupedChangedLayers[gi].name;
    const groupToAdd = groupsDiffer
      ? groupedChangedLayers.find(
          g =>
            g.name === groupedConstantLayers[gi].name &&
            !savedGroupsIds.includes(g.id)
        )
      : groupedChangedLayers[gi];

    groupToAdd.layers = [];

    for (let li = 0; li < groupedConstantLayers[gi].layers.length; li++) {
      const layerToAdd = changedLayers.find(
        l => l.id === groupedConstantLayers[gi].layers[li].id
      );
      groupToAdd.layers.push(layerToAdd);
    }

    revertedGroups.push(groupToAdd);
    savedGroupsIds.push(groupToAdd.id);
  }

  return revertedGroups;
}

function revertChanges(
  groupedConstantLayers,
  groupedChangedLayers,
  skipActive
) {
  revertPropertyChanges(groupedChangedLayers, skipActive);
  return revertOrdering(groupedConstantLayers, groupedChangedLayers);
}
function adaptCompositions(compositions) {
  function recursiveModify(composition) {
    composition.objType = composition.type;
    composition.visible = false;
    composition.indeterminate = false;
    if (composition.type === 'layer') {
      composition.type = composition.service_type;
      composition.url = composition.address;
      composition.group = 'kompozycji';
      composition.valid = isLayerValid(composition);
      composition.order = 999 + (composition.order_on_map || 0);
      composition.opacity = composition.layer_transparency
        ? (100 - composition.layer_transparency) / 100
        : 1;
    }

    if (composition.compositions && composition.compositions.length) {
      composition.compositions.forEach(childComposition => {
        recursiveModify(childComposition);
      });
    }
  }

  compositions.forEach(composition => {
    recursiveModify(composition);
  });
}
function filterInvisibleCompositions(compositions) {
  // Filter the current level compositions where is_visible_default is true
  compositions = compositions.filter(composition => {
    return composition.is_visible_default;
  });

  // Recursively filter child compositions
  compositions.forEach(composition => {
    if (composition.compositions && composition.compositions.length > 0) {
      composition.compositions = filterInvisibleCompositions(
        composition.compositions
      );
    }
  });

  return compositions;
}
function sortCompositionsRecursive(compositions) {
  for (const composition of compositions) {
    if (composition.compositions && composition.compositions.length > 0) {
      composition.compositions = sortCompositionsRecursive(
        composition.compositions
      );
    }
  }
  return compositions.sort((a, b) => a.order_on_list - b.order_on_list);
}
function getAllCompositionLayers(context, composition) {
  const allCompositionLayers = [];

  async function recursiveComposition(context, composition) {
    if (composition.objType === 'layer' && composition.valid) {
      allCompositionLayers.push(composition);
    } else if (composition.compositions && composition.compositions.length) {
      composition.compositions.forEach(childComposition => {
        recursiveComposition(context, childComposition);
      });
    }
  }

  recursiveComposition(context, composition);

  return allCompositionLayers;
}
function isLayerValid(layer) {
  return checkIfAddressIsCorrect(layer) && checkIfTypeIsCorrect(layer);
}
function checkIfAddressIsCorrect(layer) {
  return !(
    layer.objType === 'layer' &&
    (!layer.address || !layer.address.trim())
  );
}
function checkIfTypeIsCorrect(layer) {
  return !!layer.service_type;
}
async function createMapLayer(context, layer) {
  let builder = new MapLayerBuilder(
    layer,
    null,
    context.getters.coordinateSystem
  );
  layer.mapLayer = await builder.getOlLayer(null, null, context);
}
export const actions = {
  async [COMPOSITIONS_FETCH](
    context,
    { compositionId, userEmail, useStoredSettings }
  ) {
    if (!(fetchsCompositionsHelper > 1 && fetchsCompositionsHelper % 2 === 1)) {
      fetchsCompositionsHelper++;
    }

    try {
      const response = await compositionApi.getKompozycje({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        // widocznosc: true
      });
      let compositions = response.body;
      compositions = await filterInvisibleCompositions(compositions);
      if (compositions && compositions.length) {
        compositions = sortCompositionsRecursive(compositions);
        await adaptCompositions(compositions);
        await context.commit(COMPOSITIONS_SET, compositions);
      }
      // compositionId = useStoredSettings
      //   ? context.rootGetters.storedCompositionId
      //   : compositionId;
      // let selectedComposition = compositionId
      //   ? compositions.find(x => x.id === compositionId)
      //   : compositions.find(x => x.isSystem);
      // if (!selectedComposition) {
      //   selectedComposition = compositions[0];
      // }

      // context.commit(DEACTIVATE_ALL_COMPOSITIONS);
      // await context.dispatch(COMPOSITIONS_SHOW, {
      //   composition: selectedComposition,
      //   userEmail: userEmail,
      //   currentLayers: context.rootGetters.compositionGroupLayers,
      //   useStoredSettings: useStoredSettings
      // });
      // context.commit(ACTIVATE_CURRENT_COMPOSITION);
    } catch (error) {
      // window.console.log(error);
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [COMPOSITIONS_SHOW](context, { composition }) {
    // go through every layer
    //  if layer.mapLayer? turnOnCompositionLayer:createCompositionLayer:addLayerToMap

    const compositionLayers = await getAllCompositionLayers(
      context,
      composition
    );
    // window.console.log(compositionLayers);
    // window.console.log(checkedLayers);
    compositionLayers.forEach(async layer => {
      // window.console.log(layer);
      if (layer.visible) {
        if (!layer.mapLayer) {
          // window.console.log(layer);
          await createMapLayer(context, layer);
          // addMapLayerToMap(layer)
          await context.commit(LAYERS_LAYERS_ADD, [layer]);
        }

        context.commit(SET_LAYER_VISIBILITY, {
          layerId: layer.id,
          visible: true
        });
      } else {
        if (!layer.mapLayer) {
          // window.console.log(layer);
          await createMapLayer(context, layer);
          // addMapLayerToMap(layer)
          await context.commit(LAYERS_LAYERS_ADD, [layer]);
        }

        context.commit(SET_LAYER_VISIBILITY, {
          layerId: layer.id,
          visible: false
        });
      }
    });
    // forEach
  },
  async [COMPOSITIONS_HIDE](context, { composition }) {
    const checkedLayers = getAllCompositionLayers(context, composition);
  },
  async [COMPOSITIONS_SAVE](context, { composition, userEmail }) {
    const groups = context.getters.compositionLayers;

    try {
      const groupedLayers = [];

      groups
        .filter(g => g.layers.some(l => !l.hide && l.visible))
        .forEach(g => {
          const groupItems = [];
          groupItems.push({ __nazwa__: g.name || ' ' });

          const mappedLayers = g.layers
            .filter(l => !l.hide && l.visible)
            .sort((a, b) => b.order - a.order)
            .map(l => ({
              id_warstwa: l.id,
              styl: l.styleId || '',
              widocznosc: l.visible
            }));

          groupItems.push(...mappedLayers);
          groupedLayers.push(groupItems);
        });

      const compositionId = (
        await compositionApi.postKompozycje({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          body: { nazwa: composition.name, warstwy: groupedLayers }
        })
      ).body.id;

      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces',
        message: 'Kompozycja została zapisana.'
      });

      context.getters.layers.forEach(l => (l.modified = false));

      await context.dispatch(COMPOSITIONS_FETCH, {
        compositionId: compositionId,
        userEmail: userEmail
      });
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [COMPOSITIONS_DELETE](context, { composition, userEmail }) {
    try {
      await compositionApi.deleteKompozycjeById({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        id: composition.id
      });

      let currentComposition = context.getters.composition;

      //refresh layers view
      if (currentComposition && currentComposition.id === composition.id) {
        context.commit(COMPOSITIONS_CURRENT_SET, undefined);
      }

      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces',
        message: 'Kompozycja została usunięta.'
      });

      //refresh compositions list
      context.dispatch(COMPOSITIONS_FETCH, { userEmail: userEmail });
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [STYLES_SAVE](context, style) {
    try {
      let newStyleId = (
        await styleApi.postStyles({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          body: {
            styl: style
          }
        })
      ).body.id;

      let styles = (
        await styleApi.getStyles({
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          items_per_page: 10000,
          page_number: 1
        })
      ).body.style;
      //refresh styles list
      context.commit(STYLES_SET, styles);

      //set created style as layer style
      let layer = context.getters.layers.find(x => x.id === style.id_warstwy);
      layer.createdStyleId = newStyleId;
    } catch (error) {
      context.commit(WINDOW_API_ERROR_SHOW, error);
    }
  },
  async [STYLES_DELETE](context, styleId) {
    try {
      await styleApi.deleteStylesById({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        id: styleId
      });
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'success',
        title: 'Sukces.',
        message: 'Styl został usunięty.'
      });
      context.commit('removeStyleFromList', styleId);
    } catch (error) {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'error',
        title: 'Uwaga. Usunięcie stylu nie powiodło się.',
        message: 'Usunięcie stylu nie powiodło się.'
      });
    }
  },
  async [STYLES_FETCH](context) {
    let styles = (
      await styleApi.getStyles({
        wso2_id: this.contextEmail ? this.contextEmail : null,
        orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
        items_per_page: 10000,
        page_number: 1
      })
    ).body.style;
    context.commit(STYLES_SET, styles);
  },
  async [COMPOSITIONS_REVERT_CHANGES](context, skipActive) {
    context.commit(
      LAYERS_SET,
      revertChanges(
        context.state.constantLayers,
        context.state.layers,
        skipActive
      )
    );
  },
  [COMPOSITIONS_LAYER_CHANGED]({ state }) {
    state.layersChanged = hasChanges(state.constantLayers, state.layers);
  }
};

export const mutations = {
  [COMPOSITIONS_SET](state, compositions) {
    state.compositions = compositions;
  },
  [COMPOSITIONS_CURRENT_SET](state, composition) {
    state.composition = composition;
    if (fetchsCompositionsHelper % 2 == 1) {
      fetchsCompositionsHelper++;
    }
  },
  [LAYERS_SET](state, groupedLayers) {
    groupedLayers = groupedLayers || [];

    for (let groupIndex = 0; groupIndex < groupedLayers.length; ++groupIndex) {
      for (
        let layerIndex = 0;
        layerIndex < groupedLayers[groupIndex].length;
        ++layerIndex
      ) {
        const currentLayer = groupedLayers[groupIndex][layerIndex];
        if (currentLayer.mapLayer === undefined) continue;
        const tempLayer = state.layers
          .flat()
          .find(x => x.id === currentLayer.id);

        if (tempLayer) {
          currentLayer.visible = tempLayer.visible;
          currentLayer.mapLayer.setVisible(tempLayer.visible);

          if (currentLayer.mapHighResolutionLayer)
            currentLayer.mapHighResolutionLayer.setVisible(tempLayer.visible);
        }
      }
    }

    const maximumOrder = state.maximumLayerOrder;
    const ungroupedLayers = groupedLayers.map(group => group.layers).flat();
    ungroupedLayers.forEach(l => {
      setLayerProperty(
        l,
        'order',
        maximumOrder +
          (ungroupedLayers.length - 1 - ungroupedLayers.indexOf(l)),
        groupedLayers.setInitValue
      );
      l.mapLayer.setZIndex(l.order);
    });

    state.layersChanged = hasChanges(state.constantLayers, groupedLayers);
    state.layers = groupedLayers;
  },
  [STYLES_SET](state, styles) {
    let styleCountByLayer = {};
    styles.forEach(x => {
      let style = state.styles.find(y => y.id === x.id);
      if (!styleCountByLayer[x.id_warstwy]) {
        styleCountByLayer[x.id_warstwy] = 0;
      }
      if (style) {
        styleCountByLayer[x.id_warstwy] = style.index;
      } else {
        styleCountByLayer[x.id_warstwy] += 1;
      }
      x.index = styleCountByLayer[x.id_warstwy];
    });
    state.styles = styles;
  },
  [APPEND_LAYER](state, layer) {
    if (state.layers.length == 0) {
      layer.order = -1;
    } else {
      layer.order = state.layers[state.layers.length - 1].order - 1;
    }
    layer.mapLayer.setZIndex(layer.order);
    state.layers.push(layer);

    state.layers = state.layers.filter(x => true);
  },
  removeStyleFromList(state, styleId) {
    state.styles = state.styles.filter(x => x.id !== styleId);
  },
  [DEACTIVATE_ALL_COMPOSITIONS]: state => {
    state.compositions.forEach(c => (c.active = false));
  },
  [ACTIVATE_CURRENT_COMPOSITION]: state => {
    state.composition.active = true;
  },
  setConstantLayers(state, constantLayers) {
    state.constantLayers = constantLayers.map(cl => {
      if (cl.layers) {
        return {
          name: cl.name,
          layers: cl.layers.map(l => ({ id: l.id, order: l.order }))
        };
      } else {
        return { id: cl.id, order: cl.order };
      }
    });
  }
};

const getters = {
  compositions(state) {
    return state.compositions;
  },
  composition(state) {
    return state.composition;
  },
  compositionLayers(state) {
    return state.layers;
  },
  styles(state) {
    return state.styles;
  },
  styleForLayer: state => styleId => {
    return state.styles.find(x => x.id === styleId) || {};
  },
  compositionLayersChanged: state => state.layersChanged
};

export default {
  state,
  actions,
  mutations,
  getters
};
